import React, { useState, useEffect } from 'react';
import Navbar from '../../../ReusableBlocks/Navbar';
import Footer from '../../../ReusableBlocks/FooterBlock';
import { useDispatch, useSelector } from 'react-redux';
import { fetchFaqs } from '../../../Redux/Dashboard/External/FAQ/FAQAction';
import { faqSearch } from '../../../Redux/Dashboard/External/Search/FAQSearchAction';
import LoadingScreen from '../../../ReusableBlocks/LoadingScreen';
import Swal from 'sweetalert2';

const FAQ_Page = () => {
    const dispatch = useDispatch();

    const { faqList: initialFaqs, loading: initialLoading, error: initialError } = useSelector(state => state?.FAQ_Question);
    const {
        results: searchedFaqs = [],
        loading: searchLoading = false,
        error: searchError = null
    } = useSelector(state => state?.FAQSearch || {});

    const [searchQuery, setSearchQuery] = useState('');
    const [expandedIndex, setExpandedIndex] = useState(null);
    const [searchSubmitted, setSearchSubmitted] = useState(false);

    const isLoading = initialLoading || searchLoading;
    const errorMessage = searchError || initialError;

    useEffect(() => {
        dispatch(fetchFaqs());
    }, [dispatch]);


    useEffect(() => {
        if (errorMessage && errorMessage !== 'You have not completed mandatory Tech Central Training, please complete it.') {
            Swal.fire({
                title: 'Error',
                text: errorMessage,
                icon: 'error',
                showCancelButton: true,
                confirmButtonText: 'Retry',
                customClass: {
                    title: 'my-custom-title-of-pop-login',
                    confirmButton: 'my-custom-button-of-pop',
                },
            });
        }
    }, [errorMessage]);


    useEffect(() => {
        if (!searchQuery.trim()) {
            setSearchSubmitted(false);
        }
    }, [searchQuery]);
    

    const handleSearchSubmit = (e) => {
        e.preventDefault();
        if (searchQuery.trim()) {
            setSearchSubmitted(true);
            dispatch(faqSearch(searchQuery));
        }
    };
    

    const handleToggle = (index) => {
        setExpandedIndex(expandedIndex === index ? null : index);
    };

    const highlightSearchWords = (text, searchWords) => {
        return text.replace(
            new RegExp(`(${searchWords.join('|')})`, 'gi'),
            '<span class="highlighted">$1</span>'
        );
    };

    const renderFAQList = (faqListToRender) => (
        faqListToRender.map((faq, index) => (
            <div className='quest-div' key={index}>
                <center>
                    <label htmlFor={`check${index}`} className="togButton" onClick={() => handleToggle(index)}>
                        <div className='question-align'>
                            <h1
                                className='question-text'
                                dangerouslySetInnerHTML={{
                                    __html: highlightSearchWords(faq.question, searchQuery.split(' '))
                                }}
                            ></h1>
                            <div className='down-arraow'>
                                {expandedIndex === index
                                    ? <i className="fa-solid fa-chevron-up"></i>
                                    : <i className="fa-solid fa-chevron-down"></i>}
                            </div>
                        </div>
                    </label>
                </center>
                <center>
                    <input
                        type="checkbox"
                        className="togCheck"
                        id={`check${index}`}
                        checked={expandedIndex === index}
                        readOnly
                    />
                    <div className="togContent" style={{
                        maxHeight: expandedIndex === index ? '1000px' : '0',
                        opacity: expandedIndex === index ? 1 : 0,
                        visibility: expandedIndex === index ? 'visible' : 'hidden'
                    }}>
                        <div>
                            <p className='answer-tag'>Answer</p>
                            <div className='txt' dangerouslySetInnerHTML={{ __html: faq?.answer }} />
                        </div>
                    </div>
                </center>
                <br />
            </div>
        ))
    );

    return (
        <>
            {isLoading && <LoadingScreen text="Loading FAQ Questions" />}
            <Navbar activeTabSales={"FAQ"} />
            <div className='FAQ-PAGE-BACKGROUDN'>
                <div className='container'>
                    <br />
                    <div className='faq-section'>
                        <center>
                            <h1 className='freq-titile'>Frequently asked questions</h1>
                            <form onSubmit={handleSearchSubmit} className="faq-search-form">
                                <div className="search-box-container">
                                    <input
                                        placeholder="Start typing keyword"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                        type="text"
                                        className="faq-search-box"
                                    />
                                    <button type="submit" className="search-submit-button">
                                        <i className="fa fa-search"></i>
                                    </button>
                                </div>
                            </form>
                        </center>
                        <br /><br />
                        <div className='container'>
                            {searchSubmitted ? (
                                !searchLoading && searchedFaqs?.length > 0 ? (
                                    renderFAQList(searchedFaqs)
                                ) : (
                                    !searchLoading && <center>No results found.</center>
                                )
                            ) : (
                                initialFaqs?.length > 0 && renderFAQList(initialFaqs)
                            )}
                        </div>
                    </div>
                    <br />
                </div>
            </div>
        </>
    );
};

export default FAQ_Page;
